import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import * as z from "zod"
import { Button } from "@/shared/ui/button.tsx"
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/shared/ui/form.tsx"
import {
  Input
} from "@/shared/ui/input.tsx"
import { Textarea } from "@/shared/ui/textarea.tsx"
import { usePostScheduleDemo } from "../api/contact-api"
import { Loader2, PartyPopper } from "lucide-react"

const scheduleFormSchema = z.object({
  firstName: z.string().min(1, "First Name is required"),
  email: z.string().email(),
  message: z.string()
});

export type ScheduleFormDataType = z.infer<typeof scheduleFormSchema>

export default function ScheduleForm() {

  const { scheduleDemo, status } = usePostScheduleDemo()

  const form = useForm<ScheduleFormDataType>({
    mode: "onBlur",
    resolver: zodResolver(scheduleFormSchema),

  })


  function onSubmit(formData: ScheduleFormDataType) {
    scheduleDemo(formData)
      form.reset({
        firstName: "",
        email: "",
        message: ""
      })
  }

  return (
    <Form {...form}>
      {status === "success" && (
        <div className="w-full">
          <p className="text-3xl text-purple-500 py-4 flex items-center gap-2 w-full text-center justify-center font-semibold font-montserrat"><PartyPopper /> Thank you for reaching out to siAi</p>
          <p className="w-full text-center font-poppins">Our team will reach you shortly</p>
        </div>
      )}
      {status !== "success" && (
        <form onSubmit={form.handleSubmit(onSubmit)} className="w-full flex flex-col gap-3 md:w-[60%] xl:w-[50%] p-5">
          <p className="w-full text-center text-3xl font-montserrat font-medium">Schedule a Demo</p>
          <p className="font-poppins font-semibold w-full text-center bg-gradient-to-r from-purple-400 via-violet-500 to-indigo-400 inline-block text-transparent bg-clip-text tracking-wide">Limited spots available - Act now to secure your partnership!</p>

          <FormField
            control={form.control}
            name="firstName"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    placeholder="Full Name"
                    className="p-4 h-12 font-poppins"
                    {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    placeholder="Work Email"
                    className="p-4 h-12 font-poppins"
                    {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="message"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Textarea
                    placeholder="Tell us about your Goals"
                    className="font-poppins"
                    {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />
          <Button disabled={status === "pending"} type="submit" className="font-poppins bg-gradient-to-r from-purple-400 via-violet-500 to-indigo-400">{status === "pending" ? <Loader2 className="animate-spin" /> : "Submit"}</Button>
        </form>
      )}
    </Form>
  )
}
